import { overheadSummary } from './alfatexOverhead.js';
const company = (c) => c === 'iva' ? 'Ennage' : 'Genaen';
export function salesExport(lines) {
  const overhead = new Map(overheadSummary(lines).rows.map(r => [JSON.stringify([r.company,r.invoice,r.line,r.n_dup]), r]));
  return {
    headers: ['Empresa código','Empresa','Factura','Línea','Duplicado','Fecha','Cliente código','Cliente','Familia código','Familia','Artículo código','Artículo','Cantidad','Venta neta EUR','Coste unitario actual EUR','Coste asociado EUR','Origen coste','Validación escandallo','Gastos generales unitarios EUR','Gastos generales incluidos EUR'],
    rows: lines.map(r => {
      const h = overhead.get(JSON.stringify([r.company,r.invoice,r.line,r.n_dup]));
      return [r.company,company(r.company),r.invoice,r.line,r.n_dup,r.date,r.customer_code,r.customer_name,r.family_code,r.family_name || 'Sin familia',r.code,r.description,r.quantity,r.revenue,r.unit_cost,r.cost,r.cost_source,r.validation_status,h?.overheadUnit,h?.overhead];
    }),
  };
}
export function expensesExport(lines) {
  return {
    headers: ['Empresa código','Empresa','Factura proveedor','Partida','Fecha','Proveedor código','Proveedor','Cuenta','Cuenta descripción','Concepto','Importe','Moneda','Procesos asociados (sin reparto)'],
    rows: lines.map(r => [r.company,company(r.company),r.invoice,r.slot,r.date,r.supplier_code,r.supplier_name,r.account,r.account_name,r.description,r.amount,r.currency,r.processes?.map(p => p.description).join(' | ')]),
  };
}
